import * as yup from 'yup';

export const createOrUpdateOperatorRequestBodySchema = yup
  .object({
    body: yup.object({
      operatorName: yup.string().required(),
    }),
  })
  .required();
